// Constants
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
export const OPEN_ITEM_MODAL_DEFAULT_SORT_DIRECTIONS = { name: ASC, modifyDateObj: DESC };
export const ITEM_TYPE_INFO_MAP = {
    [SavedItemType.FUND_CHART]: { singularLabel: 'Fundamental Chart', pluralLabel: 'Fund Charts', isEditable: false },
    [SavedItemType.METRIC_SET]: { singularLabel: 'Metric Set', pluralLabel: 'Metric Sets', isEditable: true },
    [SavedItemType.STOCK_SCREEN]: {
        singularLabel: 'Stock Screen',
        pluralLabel: 'Stock Screens',
        isEditable: false,
    },
    [SavedItemType.TECH_CHART]: {
        singularLabel: 'Technical Chart',
        pluralLabel: 'Technical Charts',
        isEditable: false,
    },
    [SavedItemType.COMP_TABLE]: { singularLabel: 'Comp Table', pluralLabel: 'Comp Tables', isEditable: false },
    [SavedItemType.FUND_SCREEN]: { singularLabel: 'Fund Screen', pluralLabel: 'Fund Screens', isEditable: false },
    [SavedItemType.SCATTER_PLOT]: {
        singularLabel: 'Scatter Plot',
        pluralLabel: 'Scatter Plots',
        isEditable: false,
    },
    [SavedItemType.SCORE]: { singularLabel: 'Scoring Model', pluralLabel: 'Scoring Models', isEditable: true },
    [SavedItemType.TIMESERIES_TABLE]: {
        singularLabel: 'Timeseries Table',
        pluralLabel: 'Timeseries Tables',
        isEditable: false,
    },
    [SavedItemType.HYPOTHETICAL]: {
        singularLabel: 'Scenario Builder',
        pluralLabel: 'Scenarios',
        isEditable: false,
    },
    [SavedItemType.PORTFOLIO_OPTIMIZER]: {
        singularLabel: 'Portfolio Optimizer',
        pluralLabel: 'Portfolio Optimizers',
        isEditable: false,
    },
    [SavedItemType.CUSTOM_PDF_REPORT]: {
        singularLabel: 'PDF Report',
        pluralLabel: 'PDF Reports',
        isEditable: false,
    },
};
